module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Deleting IRO","text":"This action cannot be undone. Are you sure you want to delete this IRO?","cancel":"Cancel","delete":"Delete"},"de":{"title":"IRO löschen","text":"Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie dieses IRO löschen möchten?","cancel":"Cancel","delete":"Delete"}}')
  delete Component.options._Ctor
}
